import { Box, Typography, type BoxProps } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

const PanelRoot = styled(Box)(({ theme }) => ({
  position: 'relative',
  // padding: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,

  /* Subtle CRT glow */
  boxShadow: `
    0 0 0 1px rgba(125,211,199,0.15),
    0 0 18px rgba(125,211,199,0.08)
  `,
}));

const TitleDivider = styled('span')(({ theme }) => ({
  display: 'block',
  width: '100%',
  border: `1px solid ${theme.palette.divider}`,

  /* Subtle CRT glow */
  boxShadow: `
    0 0 0 0.1px rgba(125,211,199,0.15),
    0 0 18px rgba(125,211,199,0.08)
  `,
}));

export const Panel = ({
  children,
  title,
  ...props
}: BoxProps & {
  title?: string;
}) => {
  const theme = useTheme();

  return (
    <PanelRoot {...props}>
      {title && (
        <>
          <Typography
            variant="overline"
            sx={{
              color: 'secondary.main',
              letterSpacing: '0.15em',
              m: theme.spacing(1),
            }}
          >
            {title}
          </Typography>
          <TitleDivider />
        </>
      )}
      <Box sx={{ padding: theme.spacing(3) }}>{children}</Box>
    </PanelRoot>
  );
};
